module.exports = __webpack_public_path__ + "img/9040522_hand_thumbs_up_icon.85a37e6b.svg";